import { useTranslation } from 'react-i18next'

export default ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const label = t('Flag of United Kingdom.', { context: 'alt text for image of the UK flag' })

  return (
    <svg
      width="32"
      height="18"
      viewBox="0 0 32 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={label}
      className={className}
    >
      <g clipPath="url(#clip0_93_4575)">
        <path d="M-2.19836 -0.0978394V18.1005H34.1983V-0.0978394H-2.19836Z" fill="#012169" />
        <path
          d="M-2.19836 -0.0978394L34.1983 18.1005L-2.19836 -0.0978394ZM34.1983 -0.0978394L-2.19836 18.0988L34.1983 -0.0978394Z"
          fill="black"
        />
        <path
          d="M33.3851 19.7282L16.0001 11.0348L-1.38493 19.7282L-3.0116 16.4698L11.9301 8.99982L-3.0116 1.52982L-1.38493 -1.72852L16.0001 6.96482L33.3851 -1.72852L35.0117 1.52982L20.0701 8.99982L35.0117 16.4698L33.3851 19.7282Z"
          fill="white"
        />
        <path
          d="M-2.19836 -0.0978394L34.1983 18.1005L-2.19836 -0.0978394ZM34.1983 -0.0978394L-2.19836 18.0988L34.1983 -0.0978394Z"
          fill="black"
        />
        <path
          d="M33.655 19.1846L16 10.3546L-1.65503 19.1846L-2.7417 17.0129L13.2883 8.99957L-2.7417 0.986242L-1.65503 -1.18542L16 7.64457L33.655 -1.18542L34.7416 0.986242L18.7116 8.99957L34.7416 17.0129L33.655 19.1846Z"
          fill="#C8102E"
        />
        <path d="M16 -0.0978394V18.1005V-0.0978394ZM-2.19836 9.00049H34.1983H-2.19836Z" fill="black" />
        <path
          d="M19.0333 18.0988H12.9666V12.0338H-2.19836V5.96716H12.9666V-0.0978394H19.0333V5.96716H34.1983V12.0338H19.0333V18.0988Z"
          fill="white"
        />
        <path d="M16 -0.0978394V18.1005V-0.0978394ZM-2.19836 9.00049H34.1983H-2.19836Z" fill="black" />
        <path
          d="M17.82 18.0988H14.18V10.8205H-2.19836V7.18049H14.18V-0.0978394H17.82V7.18049H34.1983V10.8205H17.82V18.0988Z"
          fill="#C8102E"
        />
      </g>
      <rect x="0.5" y="0.5" width="31" height="17" stroke="black" strokeOpacity="0.05" />
      <defs>
        <clipPath id="clip0_93_4575">
          <rect width="32" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
